import { Box } from "@mui/material";
import {
  AccountTree,
  Cable,
  DashboardCustomize,
  Dashboard,
  DocumentScanner,
  Forum,
  NotInterested,
  Science,
  Reviews,
  Assessment,
  Sms,
  SupportAgent,
  Feed,
  ListAlt,
  LegendToggle,
  Addchart,
} from "@mui/icons-material";
import { ModelTraining } from "@mui/icons-material";

interface IMenuConfig {
  caption: string;
  id: string;
  link?: string;
  faIcon: JSX.Element | string;
  auth?: string;
  disabled?: boolean;
  submenu?: IMenuConfig[];
}

const BaseConfigHead: IMenuConfig[] = [];
const BaseConfigTail: IMenuConfig[] = [];

const NlpMenuConfig: IMenuConfig[] = [
  ...BaseConfigHead,
  {
    caption: "DashBoard",
    id: "menu-dashboard",
    link: "/Dashboard",
    faIcon: <Dashboard />,
    auth: "Dashboard",
  },
  {
    caption: "Talk-to-VirtualAssistant",
    id: "menu-talk-to-virtual-assistant",
    link: "/Talk2VA",
    faIcon: "syva_logo",
    auth: "Talk2VA",
    submenu: [
      {
        caption: "T2VATrainer",
        id: "menu-t2vatrainer",
        link: "/T2VATrainer",
        faIcon: <ModelTraining />,
        auth: "T2VATrainer",
      },
    ],
  },
  {
    caption: "FAQs",
    id: "menu-faq",
    link: "/FAQ",
    faIcon: "fas fa-comments fa-lg",
    auth: "FAQ",
    submenu: [
      {
        caption: "Counter Examples",
        id: "menu-counter-examples",
        link: "/FAQ/CounterExample",
        faIcon: <NotInterested />,
        auth: "Workspace.CounterExample",
      },
    ],
  },
  {
    caption: "Workspace",
    id: "menu-workspace",
    faIcon: "fas fa-crop-alt fa-lg",
    auth: "Workspace",
    link: "/Workspace",
    disabled: true,
    submenu: [
      {
        caption: "Intents",
        id: "menu-intents",
        link: "/Workspace/Intent",
        faIcon: "fas fa-crosshairs fa-lg",
        auth: "Workspace.Intent",
      },
      {
        caption: "Entities",
        id: "menu-entities",
        link: "/Workspace/Entity",
        faIcon: "fas fa-puzzle-piece fa-lg",
        auth: "Workspace.Entity",
      },
      {
        caption: "Answers",
        id: "menu-answers",
        link: "/Answer",
        faIcon: "fas fa-comment-dots fa-lg",
        auth: "Answer",
      },
    ],
  },
  {
    caption: "Report",
    id: "menu-Report",
    faIcon: <Assessment />,
    auth: "Report",
    link: "/Report",
    disabled: true,
    submenu: [
      {
        caption: "Traffic Report",
        id: "menu-Traffic",
        link: "/Report/Traffic",
        faIcon: <LegendToggle />,
        auth: "Report.Traffic",
      },
      {
        caption: "API Usage Report",
        id: "menu-APIUsage",
        link: "/Report/APIUsage",
        faIcon: <Addchart />,
        auth: "Report.APIUsage",
      },
      {
        caption: "Frequently Ask Report",
        id: "menu-FrequentlyAsk",
        link: "/Report/FrequentlyAsk",
        faIcon: <ListAlt />,
        auth: "Report.FrequentlyAsk",
      },
      {
        caption: "Survey Result",
        id: "menu-SurveyResult",
        link: "/Report/SurveyResult",
        faIcon: <Sms />,
        auth: "Report.Survey",
      },
      {
        caption: "Answer Review Report",
        id: "menu-answerreview",
        link: "/Report/AnswerReview",
        faIcon: <Reviews />,
        auth: "Report.AnswerReview",
      },
      {
        caption: "Live Agent Redirect Report",
        id: "menu-LiveAgent",
        link: "/Report/LiveAgent",
        faIcon: <SupportAgent />,
        auth: "Report.LiveAgent",
      },
      {
        caption: "EService Redirect Report",
        id: "menu-EService",
        link: "/Report/EService",
        faIcon: <Feed />,
        auth: "Report.EService",
      },
    ],
  },
  {
    caption: "Conversation",
    id: "menu-conversation",
    link: "/Convlog",
    faIcon: <Forum />,
    auth: "Convlog",
  },
  {
    caption: "Audit Log",
    id: "request-log",
    link: "/RequestLog",
    faIcon: <Cable />,
    auth: "RequestLog",
  },
  {
    caption: "Training",
    id: "menu-training",
    link: "/Training",
    faIcon: "fas fa-robot fa-lg",
    auth: "Training",
  },

  {
    caption: "Flow Editor",
    id: "menu-fle",
    link: "/FLE",
    faIcon: <AccountTree />,
    auth: "FLE",
  },
  {
    caption: "System",
    id: "menu-system",
    link: "/System",
    faIcon: "fas fa-cog fa-lg",
    auth: "System",
  },

  ...BaseConfigTail,
];

const MlMenuConfig = [
  {
    caption: "GPT-QA Dashboard",
    id: "gpt-qa-dashboard",
    link: "/gpt-qa/gpt-qa-dashboard",
    faIcon: <DashboardCustomize />,
    auth: "GPTQA.Dashboard",
  },
  {
    caption: "Technology Previews",
    id: "menu-technology-previews",
    link: "/TechnologyPreviews",
    faIcon: <Science />,
    auth: "TechnologyPreviews",
    submenu: [
      {
        caption: "AWS LiveChat",
        id: "menu-aws-livechat",
        link: "/AWSLiveChat",
        faIcon: (
          <Box height={"25px"}>
            <img style={{ height: "100%" }} src={`${process.env.PUBLIC_URL}/Images/AWS/aws_connect_icon.png`} alt="ic_connect"></img>
          </Box>
        ),
        auth: "AWSLiveChat",
      },
      {
        caption: "Avatar development",
        id: "menu-avatar-development",
        link: "/Avatar",
        faIcon: "far fa-grin-alt",
        auth: "Avatar",
      },
    ],
  },
  {
    caption: "T2GA",
    id: "menu-deep-learning",
    link: "/TestChat",
    faIcon: "syva_logo",
    auth: "DeepLearning",
  },
  {
    caption: "Document Manager",
    id: "menu-document-manager",
    link: "/gpt-qa/document-manager",
    faIcon: <DocumentScanner />,
    auth: "GPTQA.DocumentManager",
  },
  {
    caption: "Document Conversation",
    id: "menu-conversation-log",
    link: "/gpt-qa/conversation-log",
    faIcon: <Forum />,
    auth: "GPTQA.ConversationLog",
  },
  {
    caption: "GPT Setting",
    id: "menu-GPT-Setting",
    link: "/gpt-qa/gpt-setting",
    faIcon: "fas fa-cog fa-lg",
    auth: "GPTQA.GPTSettings",
  },
];

export enum MenuConfigMode {
  ML = "ml",
  NLP = "nlp",
}

export const MenuConfig = (configMode: MenuConfigMode) => {
  switch (configMode) {
    case "ml":
      return NlpMenuConfig;
    case "nlp":
      return NlpMenuConfig;
    default:
      return NlpMenuConfig;
  }
};
